import React from "react";
import {
  Page,
  TableContainer,
  withTable,
  Pagination,
  FormGroup,
  DatePicker,
  SubmitButton
} from "components/common";
import { formatXeroDate } from "services/util";
import { LocalForm, Control, actions } from "react-redux-form";
import { compose, withStateHandlers, shallowEqual } from "recompose";
import { get, mapValues, isString, pick, merge, chain } from "lodash";
import { formatCurrency } from "services/util";
import { Trans } from "react-i18next";
import {
  Row,
  Col,
  Button,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,Label,Table
} from "reactstrap";
import moment from "moment";
import shortid from "shortid";
import { Link } from "react-router-dom";
import BackButton from "components/refactoring/BackButton";

const initialState = {
  description: "",
  minimum_amount: "",
  maximum_amount: "",
  minimum_exact_amount: false,
  maximum_exact_amount: false,
  start_date: null,
  end_date: null,
  exact_date: false,
};

export const BankTransactions = ({
  account,
  data,
  ordering,
  match,
  offset,
  setOrdering,
  limit,
  url,
  setData,
  setOffset,
  filters,
  t,
  setState,
  dispatch,
  handleSubmit,
  handleChange,
  setDispatch,
  search = {},
  handleClear,
  loading,
  fromDate,
  toDate,
  ...props
}) => {

  const urlParams = new URLSearchParams(window.location.search);
  const isRemoveRedo = urlParams.get('removeRedo') === "True"
  const redoLink = `${match.url}/${urlParams.get('Type') === "SPEND" ? `spend` : `receive`}/new`

const headerStyle = {
  name: {
    style: { fontWeight: 'bold', fontSize: '1.4em', color: '#72B566'},
    className: "pl-1"
  },
  content: {
    style: { fontSize: '1.2em'},
    className: "text-left pb-4"
  },
  code: {
    style: { fontSize: '0.8em', color: '#A5A5A5'},
  },
};
  return (

  <Page title={account?.Name || "Bank Account"} showTitle={false} translate={false}>
    <BackButton styleClass="my-2"/>
    <div {...headerStyle.content}>
      <span>
        Account Transactions for <span {...headerStyle.name}>{account.Name}</span> {account && account.Code && (<span {...headerStyle.code}>({account.Code})</span>)}
      </span>
    </div>
    <LocalForm
      initialState={initialState}
      getDispatch={setDispatch}
      onChange={handleChange}
      onSubmit={handleSubmit}
    >
      <div>
        <Row className="small">
          <Col>
            <FormGroup
              label="Description, contact name or any reference"
              className="text-nowrap"
            >
              <Control.text className="form-control-sm" model=".description" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Minimum Amount" className="text-nowrap">
              <Control.text
                type="number"
                model=".minimum_amount"
                step="any"
                className="form-control-sm "
              />
              <FormGroup check>
                <Label style={{position:'absolute', top:'2px'}} className="text-nowrap"><Trans>Exact amount</Trans></Label>
                <Control.checkbox model=".minimum_exact_amount" />
              </FormGroup>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Maximum Amount" className="text-nowrap">
              <Control.text
                type="number"
                step="any"
                className="form-control-sm"
                model=".maximum_amount"
              />
              <FormGroup check>
              <Label style={{position:'absolute', top:'2px'}}><Trans>Exact amount</Trans></Label>
                <Control.checkbox model=".maximum_exact_amount" />
              </FormGroup>
            </FormGroup>
          </Col>
          <Col className={search && search.exact_date ? "d-none" : ""}>
            <FormGroup label="Start Date" className="text-nowrap">
              <DatePicker
                className="form-control form-control-sm"
                model=".start_date"
              />
              <FormGroup check>
              <Label style={{position:'absolute',top:'2px'}}><Trans>Exact date</Trans></Label>
                <Control.checkbox model=".exact_date" />
              </FormGroup>
            </FormGroup>
          </Col>
          <Col className={search && search.exact_date ? "d-none" : ""}>
            <FormGroup label="End Date">
              <DatePicker
                className="form-control form-control-sm"
                model=".end_date"
              />
            </FormGroup>
          </Col>
          <Col className={search && !search.exact_date ? "d-none" : ""}>
            <FormGroup label="Date">
              <DatePicker
                className="form-control form-control-sm"
                model=".date"
              />
              <FormGroup check label="Exact Date">
                <Control.checkbox model=".exact_date" />
              </FormGroup>
            </FormGroup>
          </Col>
        </Row>
        <div
          className="d-flex justify-content-end mb-2 mt-3 mr-4"
 >
          <Button className="btn-sm" onClick={handleClear}>
            <Trans>Clear</Trans>
          </Button>
          <div className="mx-1" />
          <SubmitButton className="btn-sm">Search</SubmitButton>
        </div>
      </div>
    </LocalForm>
    <div className="d-flex justify-content-end align-items-center mb-3 mt-3">
      <div className="mr-auto">
        <UncontrolledButtonDropdown>
          <DropdownToggle caret color="primary" className="btn-sm">
            <span className="fa fa-plus mr-2" /> <Trans>New Transaction</Trans>
          </DropdownToggle>
          <DropdownMenu>
            <Link className="dropdown-item" to={`${match.url}/spend/new`}>
              <Trans>Spend Money</Trans>
            </Link>
            <Link className="dropdown-item" to={`${match.url}/receive/new`}>
              <Trans>Receive Money</Trans>
            </Link>
            <Link className="dropdown-item" to={`${match.url}/transfer`}>
              <Trans>Transfer Money</Trans>
            </Link>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      </div>
      <div className="mr-3 text-muted small">
        {fromDate} <Trans>to</Trans> {toDate}
      </div>
      {!!loading && (
        <div>
          <span className="fa fa-spinner fa-spin mr-2" />
        </div>
      )}
    </div>
    {isRemoveRedo &&       
      <div className="alert alert-success fade show my-3" role="alert">
        <ul className="mb-0 pl-3 text-center">
          <li>
            <span style={{fontSize: "1.1em"}}><i className="fa fa-check text-success mr-2" style={{fontSize: "1.4em"}}/><Trans>The account transaction has been removed. You can now redo this transaction by <Link to={redoLink}>adding a payment</Link>.</Trans></span>
          </li>
        </ul>
      </div>
    }
    <TableContainer items={data.results} className="table table-sm small" >
      <Table responsive>
        <thead>
          <tr>
            <th>
              <Trans>Date</Trans>
            </th>
            <th>
              <Trans>Description</Trans>
            </th>
            <th>
              <Trans>Reference</Trans>
            </th>
            <th>
              <Trans>Payment Reference</Trans>
            </th>
            <th className="text-right">
              <Trans>Spend</Trans>
            </th>
            <th className="text-right">
              <Trans>Received</Trans>
            </th>
            <th>
              <Trans>Status</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {data
          .filter((i) => (i.BankAccount?.AccountID || i.Account?.AccountID) === account?.AccountID)
          .map((i) => (
            <React.Fragment key={i.key}>
              <tr>
                <td className="text-nowrap">{i.DateString}</td>
                <td>{i.Description || t("Transaction")}</td>
                <td>{i.Reference || ("-")}</td>
                <td>{i.PaymentRef || ("-")}</td>
                <td className="text-right">
                  {!!i.Spend && formatCurrency(i.Spend)}
                </td>
                <td className="text-right">
                  {!!i.Receive && formatCurrency(i.Receive)}
                </td>
                <td>
                  {i.IsReconciled ? (
                    <span className="text-success">
                      <Trans>Reconciled</Trans>
                    </span>
                  ) : (
                    <span className="text-warning">
                      <Trans>Unreconciled</Trans>
                    </span>
                  )}
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <div className="d-flex justify-content-end">
      {!!loading && (
        <div>
          <span className="fa fa-spinner fa-spin mr-2" />
        </div>
      )}
      <Pagination
        size="sm"
        count={0}
        noPages
        limit={limit}
        offset={offset}
        onOffsetChanged={setOffset}
      />
    </div>
  </Page>
)};

const withLoader = (BaseComponent) =>
  class extends React.Component {
    state = {
      fromDate: moment().subtract(6, "month").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    componentDidMount = () => {
      const {
        props: { xero, match },
      } = this;
      const { id } = match.params;

      xero
        .get(`accounts/${id}`)
        .get("data")
        .then((account) => {
          this.mounted = true;
          this.setState({ account }, this.loadData);
        });
    };

    getPaymentFilters = () => {
      let { searchFilters } = this.props;
      let raw = undefined;
      const { fromDate, toDate } = this.state;
      const items = [];
      const wpFilters = {};

      if (searchFilters) {
        const search = mapValues(searchFilters, (v) =>
          isString(v) ? v.replace(/"/g, "").toLowerCase() : v
        );

        if (search.description) {
          items.push(
            `((Invoice.InvoiceNumber!=null AND Invoice.InvoiceNumber.ToLower().Contains("${search.description}")) OR (Invoice.Contact.Name!=null AND Invoice.Contact.Name.ToLower().Contains("${search.description}")) OR (Reference!=null AND Reference.ToLower().Contains("${search.description}")))`
          );
          wpFilters.search = search.description;
        }
        if (search.minimum_amount) {
          if (search.minimum_exact_amount) {
            items.push(`BankAmount=${search.minimum_amount}`);
            wpFilters.BankAmount = search.minimum_amount;
          } else {
            items.push(`BankAmount>=${search.minimum_amount}`);
            wpFilters.BankAmount__gte = search.minimum_amount;
          }
        }
        if (search.maximum_amount) {
          if (search.maximum_exact_amount) {
            items.push(`BankAmount=${search.maximum_amount}`);
            wpFilters.BankAmount__gte = search.maximum_amount;
          } else {
            items.push(`BankAmount<=${search.maximum_amount}`);
            wpFilters.BankAmount__gte = search.maximum_amount;
          }
        }
        if (search.exact_date) {
          if (search.date) {
            items.push(`Date=${formatXeroDate(search.date)}`);
            wpFilters.Date = search.date;
          }
        } else {
          if (search.start_date) {
            items.push(`Date>=${formatXeroDate(search.start_date)}`);
            wpFilters.Date__gte = search.date;
          }
          if (search.end_date) {
            items.push(`Date<=${formatXeroDate(search.end_date)}`);
            wpFilters.Date__lte = search.end_date;
          }
        }
      } else {
        items.push(
          `(Date>=${formatXeroDate(fromDate)} AND Date<=${formatXeroDate(
            toDate
          )})`
        );
        wpFilters.Date__gte = fromDate;
        wpFilters.Date__lte = toDate;
      }

      items.push(`(Account.AccountID=Guid("${this.state.account.AccountID}"))`);
      wpFilters.Account = this.state.account.AccountID;
      wpFilters.page = 1;
      raw = items.join(" AND ");
      return {
        raw: raw || undefined,
        ...wpFilters,
      };
    };

    getBankTransactionFilters = () => {
      let { searchFilters } = this.props;
      const { fromDate, toDate } = this.state;
      let raw = undefined;
      const items = [];

      let filters = {};

      if (searchFilters) {
        const search = mapValues(searchFilters, (v) =>
          isString(v) ? v.replace(/"/g, "").toLowerCase() : v
        );

        if (search.description) {
          items.push(
            `((Reference!=null AND Reference.ToLower().Contains("${search.description}")) OR (Contact.Name!=null AND Contact.Name.ToLower().Contains("${search.description}")))`
          );
          filters["search"] = search.description;
        }
        if (search.minimum_amount) {
          if (search.minimum_exact_amount) {
            items.push(`Total=${search.minimum_amount}`);
            filters["Total"] = search.minimum_amount;
          } else {
            items.push(`Total>=${search.minimum_amount}`);
            filters["Total__gte"] = search.minimum_amount;
          }
        }
        if (search.maximum_amount) {
          if (search.maximum_exact_amount) {
            items.push(`Total=${search.maximum_amount}`);
            filters["Total"] = search.maximum_amount;
          } else {
            items.push(`Total<=${search.maximum_amount}`);
            filters["Total__lte"] = search.maximum_amount;
          }
        }
        if (search.exact_date) {
          if (search.date) {
            items.push(`Date=${formatXeroDate(search.date)}`);
            filters["Date"] = search.date;
          }
        } else {
          if (search.start_date) {
            items.push(`Date>=${formatXeroDate(search.start_date)}`);
            filters["Date__gte"] = search.start_date;
          }
          if (search.end_date) {
            items.push(`Date<=${formatXeroDate(search.end_date)}`);
            filters["Date__lte"] = search.end_date;
          }
        }
      } else {
        items.push(
          `(Date>=${formatXeroDate(fromDate)} AND Date<=${formatXeroDate(
            toDate
          )})`
        );
        filters["Date__gte"] = fromDate;
        filters["Date__lte"] = toDate;
      }

      items.push(`(BankAccount.AccountID=Guid("${this.state.account.AccountID}"))`);

      raw = items.join(" AND ");
      filters['page'] = 1;

      filters.extra_params = {
        BankAccountID: this.state.account.AccountID,
      };
      filters.BankAccount = this.state.account.AccountID;
      filters.raw = raw || undefined;
      return filters;
    };

    handleOffsetChanged = (prevOffset) => {
      if (this.props.offset > prevOffset) {
        this.setState(({ fromDate, toDate }) => ({
          toDate: fromDate,
          fromDate: moment(fromDate).subtract(1, "month").format("YYYY-MM-DD"),
        }));
      } else {
        this.setState(({ fromDate, toDate }) => ({
          fromDate: toDate,
          toDate: moment(toDate).add(1, "month").format("YYYY-MM-DD"),
        }));
      }
    };

    componentDidUpdate = ({ offset, searchFilters }, { fromDate, toDate }) => {
      const { state, props } = this;

      if (props.offset !== offset) {
        this.handleOffsetChanged(offset);
      } else if (
        !shallowEqual(
          {
            fromDate,
            toDate,
            searchFilters,
          },
          {
            fromDate: state.fromDate,
            toDate: state.toDate,
            searchFilters: props.searchFilters,
          }
        )
      ) {
        this.loadData();
      }
    };

    loadData = () => {
      const {
        props: { xero, t },
      } = this;
      const paymentTranslation = "Payment: {{ ContactName }}";

      this.setState({ loading: true });

      Promise.props({
        payments: xero
          .get("payments", {
            params: this.getPaymentFilters(),
          })
          .get("data")
          .map((i) => {
            let Description = null;
            let Reference = null;
            let PaymentRef = null;
            let Spend = null;
            let Receive = null;

            if (
              i.PaymentType === "ACCPAYPAYMENT" ||
              i.PaymentType === "ACCRECPAYMENT" ||
              i.PaymentType === "ARCREDITPAYMENT" ||
              i.PaymentType === "APCREDITPAYMENT"
            ) {
              Description = t(paymentTranslation, {
                ContactName: get(i, "Invoice.Contact.Name"),
              });
              Reference = get(i, "Invoice.InvoiceNumber");
              PaymentRef = get(i, "Reference");
              Spend = i.PaymentType === "ACCPAYPAYMENT" ? i.BankAmount : null;
              Receive = i.PaymentType === "ACCRECPAYMENT" ? i.BankAmount : null;
            } else {
              return null;
            }

            return merge(i, {
              key: shortid(),
              Description: (
                <Link to={`/payments/${i.PaymentID}`}>{Description}</Link>
              ),
              Reference,
              PaymentRef,
              Spend,
              Receive,
              DateString: moment(i.Date).format("YYYY-MM-DD"),
            });
          }),
        bankTransactions: xero
          .get("banktransactions", {
            params: this.getBankTransactionFilters(),
          })
          .get("data")
          .map((i) => {
            let Description = null;
            let Reference = i.Reference || null ;
            let Spend = null;
            let Receive = null;
            let IsReconciled = i.IsReconciled;
            const overpayment =
              i.Type === "SPEND-OVERPAYMENT" ||
              i.Type === "RECEIVE-OVERPAYMENT";
            const prepayment =
              i.Type === "SPEND-PREPAYMENT" || i.Type === "RECEIVE-PREPAYMENT";

            if (i.Type === "SPEND-TRANSFER") {
              // Description = get(i, "LineItems.0.Description");
              Description = "Transfer: Spend"
              Spend = i.Total;
              IsReconciled = get(i, "IsReconciled");
            } else if (i.Type === "RECEIVE-TRANSFER") {
              // Description = get(i, "LineItems.0.Description");
              Description = "Transfer: Receive"
              Receive = i.Total;
              IsReconciled = get(i, "IsReconciled");
            } else if (
              i.Type === "SPEND" ||
              i.Type === "SPEND-OVERPAYMENT" ||
              i.Type === "SPEND-PREPAYMENT"
            ) {
              Description = get(i, "Contact.Name");
              Spend = i.Total;
            } else if (
              i.Type === "RECEIVE" ||
              i.Type === "RECEIVE-OVERPAYMENT" ||
              i.Type === "RECEIVE-PREPAYMENT"
            ) {
              Description = get(i, "Contact.Name");
              Receive = i.Total;
            } else {
              return null;
            }

            return merge(i, {
              key: shortid(),
              Description:
                i.Type === "SPEND-TRANSFER" ||
                i.Type === "RECEIVE-TRANSFER" ||
                i.Type === "SPEND" ||
                i.Type === "RECEIVE" ||
                overpayment ||
                prepayment ? (
                  <Link to={`/transactions/${i.BankTransactionID}`}>
                    {overpayment && <Trans>Overpayment: {{ Description }}</Trans>}
                    {prepayment && <Trans>Prepayment: {{ Description }}</Trans>}
                    {!overpayment && !prepayment && t(Description)}
                  </Link>
                ) : (
                  t(Description)
                ),
              Reference,
              Spend,
              Receive,
              IsReconciled,
              DateString: moment(i.Date).format("YYYY-MM-DD"),
            });
          }),
      })
        .then(({ payments, bankTransactions }) => {
          const data = chain([...payments, ...bankTransactions])
            .compact()
            .orderBy(["DateString", "UpdatedDateUTC"], ["desc", "desc"])
            .reject((i) => i.Status === "DELETED")
            .value();

          this.setState({
            data,
            ready: true,
          });
        })
        .finally(() => this.setState({ loading: false }));
    };

    render = () => {
      if (!this.state.ready) return null;
      const state = pick(this.state, [
        "account",
        "data",
        "loading",
        "fromDate",
        "toDate",
      ]);
      return (
        <BaseComponent {...this.props} loadData={this.loadData} {...state} />
      );
    };
  };

export const enhance = compose(
  withTable({ limit: 100 }),
  withStateHandlers(
    {
      search: {},
    },
    {
      setDispatch: () => (dispatch) => ({ dispatch }),
      handleChange: () => (search) => ({ search }),
      handleSubmit: () => (search) => ({ searchFilters: search }),
      handleClear:
        ({ dispatch }) =>
        () => {
          dispatch(actions.reset("local"));
          return { searchFilters: null };
        },
    }
  ),
  withLoader
);

export default enhance(BankTransactions);
